import {
	Anchor,
	Breadcrumbs,
	Burger,
	Divider,
	Drawer,
	Flex,
	Group,
	Image,
	Indicator,
	Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useEffect } from "react";
import { Link, useLocation } from "react-router";
import { useGetChatUnreadCountQuery } from "@/setup/frontend/api/apiHooks";
import { MagicBox } from "@/components/MagicBox";
import { MainMetaSettings } from "./MainMetaSettings";
import MainNav from "./MainNav";

export type PageHeaderProps = {
	title: string;
	breadcrumbs: {
		title: string;
		href: string;
	}[];
	toolbar?: React.ReactNode;
};

export function MobileMenu() {
	const [mobileOpened, { toggle: toggleMobile, close: closeMobile }] =
		useDisclosure();
	const unreadCount = useGetChatUnreadCountQuery();
	const location = useLocation();

	useEffect(() => {
		closeMobile();
	}, [location.pathname]);

	return (
		<Group hiddenFrom="md">
			<Indicator
				color="red"
				disabled={!unreadCount.data?.unreadCount}
				label={unreadCount.data?.unreadCount}
				size={16}
				position="top-end"
			>
				<Burger opened={mobileOpened} onClick={toggleMobile} size="sm" />
			</Indicator>
			<Drawer.Root
				opened={mobileOpened}
				onClose={closeMobile}
				position="left"
				size="sm"
				h="100%"
			>
				<Drawer.Overlay />
				<Drawer.Content
					h="100%"
					w={300}
					style={{
						display: "flex",
						flexDirection: "column",
						flex: 1,
					}}
				>
					<Drawer.Header
						style={{
							paddingTop:
								"calc(var(--safe-area-inset-top) + var(--mantine-spacing-xs))",
						}}
					>
						<Group justify="space-between" align="center" w="100%">
							<Link to="/">
								<Image src="/logo512.png" w={30} />
							</Link>
							<Drawer.Title>Menu</Drawer.Title>
							<Drawer.CloseButton />
						</Group>
					</Drawer.Header>
					<Divider />

					<Drawer.Body
						style={{ display: "flex", flexDirection: "column", flex: 1 }}
						p="sm"
					>
						<MainNav />
						<MainMetaSettings />
					</Drawer.Body>
				</Drawer.Content>
			</Drawer.Root>
		</Group>
	);
}
export function PageHeader({ title, breadcrumbs, toolbar }: PageHeaderProps) {
	return (
		<MagicBox column>
			<MagicBox spaceBetween p="md" pt="sm" row gap="md">
				<MagicBox column>
					<Title order={4} visibleFrom="sm" mb={0}>
						{title}
					</Title>
					<Title order={6} hiddenFrom="sm" mb={0}>
						{title}
					</Title>
					{breadcrumbs.length > 0 && (
						<Breadcrumbs separator="/" separatorMargin="xs">
							{breadcrumbs.map((crumb) => (
								<Anchor component={Link} key={crumb.href} to={crumb.href}>
									{crumb.title}
								</Anchor>
							))}
						</Breadcrumbs>
					)}
				</MagicBox>
				<MagicBox row flex={1} right centerY gap="sm">
					{toolbar} <MobileMenu />
				</MagicBox>
			</MagicBox>
			<Divider size={"xs"} />
		</MagicBox>
	);
}
